import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'src/components';
import { FormItemCommonProps } from '.';
import { livingStartDateRule } from '../rules';

export const LivingStartDateFormItem = ({ disabled }: FormItemCommonProps) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('Living start date')}
      name="livingStartDate"
      rules={[livingStartDateRule()]}
    >
      <DatePicker disabled={disabled} />
    </Form.Item>
  );
};
